import React from 'react';
import ThemaLaag from './ThemaLaag';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import LockScreen from './components/LockScreen';
import FoutVanger from './components/FoutVanger';
import { LayoutEditProvider } from './context/LayoutEditContext';
import Sidebar from './components/Sidebar';
import SearchBar from './components/SearchBar';
import Login from './pages/Login';
import BedrijfRegistratie from './pages/BedrijfRegistratie';
import Dashboard from './pages/Dashboard';
import { isFormsOnly, isServicedesk } from './utils/host';
import ServicedeskApp from './pages/ServicedeskApp';
import './App.css';
import SuperAdminPanel from './pages/SuperAdminPanel';
import DemoAanvragen from './pages/DemoAanvragen';
import AdminLayout from './components/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminIdeeen from './pages/admin/AdminIdeeen';
import AdminAbonnementen from './pages/admin/AdminAbonnementen';
import AdminFacturen from './pages/admin/AdminFacturen';
import Import from "./pages/Import";
import WerkorderDetail from './pages/WerkorderDetail';
import AfdelingenBeheer from './pages/AfdelingenBeheer';
import RollenBeheer from './pages/RollenBeheer';
import PortalBeheer from './pages/PortalBeheer';
import LiveScherm from './pages/LiveScherm';
import GebruikersBeheer from './pages/GebruikersBeheer';
import Klantenboek from './pages/Klantenboek';
import Inzetmiddelen from './pages/Inzetmiddelen';
import Opdrachtgevers from './pages/Opdrachtgevers';
import Facturen from './pages/Facturen';
import KlantDetail from './pages/KlantDetail';
import Toolboxen from './pages/Toolboxen';
import UrenExport from './pages/UrenExport';

import RestwerkDashboard from './pages/RestwerkDashboard';
import AfgerondeWerkorders from './pages/AfgerondeWerkorders';
import DoorgestuurdeWerkorders from './pages/DoorgestuurdeWerkorders';
import OnderaannemersBeheer from './pages/OnderaannemersBeheer';
import MijnVoorstellen from './pages/MijnVoorstellen';
import OpenWerkorders from './pages/OpenWerkorders';
import ChecklistTemplates from './pages/ChecklistTemplates';
import MetingenInbox from './pages/MetingenInbox';
import ChecklistBlokken from './pages/ChecklistBlokken';
import ThemaBeheer from './pages/ThemaBeheer';
import ChecklistInvullen from "./pages/ChecklistInvullen";
import Instellingen from './pages/Instellingen';
import OnderhoudOverzicht from './pages/OnderhoudOverzicht';
import Weekrapport from './pages/Weekrapport';
import MonteurKoppels from './pages/MonteurKoppels';
import LandingPage from './pages/LandingPage';
import WachtwoordVergeten from './pages/WachtwoordVergeten';
import ResetWachtwoord from './pages/ResetWachtwoord';
import StoringMelden from './pages/StoringMelden';
import WerkvoorbereiderPlanning from "./pages/WerkvoorbereiderPlanning";
import PlanningRouter from "./components/PlanningRouter";
import OnderhoudForecast from "./components/OnderhoudForecast";
import StoringenOverzicht from './pages/StoringenOverzicht';
import Meldingen from './pages/Meldingen';
import MeldingDetail from './pages/MeldingDetail';
import StoringDetail from './pages/StoringDetail';
import MonteurPlanning from './pages/MonteurPlanning';
import Projecten from "./pages/Projecten";
import ProjectDetail from "./pages/ProjectDetail";
import MateriaalBestellingen from "./pages/MateriaalBestellingen";
import Inhuur from "./pages/Inhuur";
import InhuurRespond from "./pages/InhuurRespond";
import MaterialenBeheer from "./pages/MaterialenBeheer";
import VoorraadOverzicht from "./pages/VoorraadOverzicht";
import KennisbankBeheer from './pages/KennisbankBeheer';
import FormsBeheer from './pages/FormsBeheer';
import SignaleringBeheer from './pages/SignaleringBeheer';
import GeoHeatmap from './pages/GeoHeatmap';
import FormsEditor from './pages/FormsEditor';
import FormsInvullen from './pages/FormsInvullen';
import QuickSignMulti from './pages/QuickSignMulti';
import SignPage from './pages/SignPage';
import FormsBekijken from './pages/FormsBekijken';
import MonteurProfiel from './pages/MonteurProfiel';
import CursusPlanner from './pages/CursusPlanner';
import Analyse from './pages/Analyse';
import StoringAnalyse from './pages/StoringAnalyse';
import Maandverslag from './pages/Maandverslag';
import MonteurLogs from './pages/MonteurLogs';
import TopDeskIntegratie from './pages/TopDeskIntegratie';
import Documenten from './pages/Documenten';
import Formulieren from './pages/Formulieren';
import MagicLinkForm from './pages/MagicLinkForm';
import VerifyPage from './pages/VerifyPage';
import FormsInboxPage from './pages/FormsInboxPage';
import FormsInstellingen from './pages/FormsInstellingen';
import Brieven from './pages/Brieven';
import Ideeen from './pages/Ideeen';
import Ordernummers from './pages/Ordernummers';
import Wagenpark from './pages/Wagenpark';
import Nieuw from './pages/Nieuw';
import Nieuws from './pages/Nieuws';
import NieuwsArtikel from './pages/NieuwsArtikel';
import NieuwsBeheer from './pages/NieuwsBeheer';
import NieuwsLive from './pages/NieuwsLive';
import NieuwsBanner from './components/nieuws/NieuwsBanner';
import AdminChangelog from './pages/admin/AdminChangelog';
import Footer from './components/Footer';
import BriefEditor from './pages/BriefEditor';

import InhuurBundelRespond from './pages/InhuurBundelRespond';
import InzetReserveren from './pages/InzetReserveren';
const Layout = ({ children }) => {
  const { gebruiker } = useAuth();
  const showSidebar = gebruiker && gebruiker.rol !== 'monteur' && !isServicedesk();
  if (isServicedesk()) return children;
  
  return (
    <div className="app-layout">
      {showSidebar && <Sidebar />}
      <main className={`main-content ${showSidebar ? 'with-sidebar' : ''}`}>
        {showSidebar && <NieuwsBanner />}
        {showSidebar && (
          <div className="main-topbar" style={{ position: 'sticky', top: 0, zIndex: 900, display: 'flex', justifyContent: 'flex-end', padding: '10px 16px', background: 'rgba(255,255,255,0.85)', backdropFilter: 'blur(6px)', borderBottom: '1px solid #e5e7eb' }}>
            <SearchBar />
          </div>
        )}
        {children}
        <Footer />
      </main>
    </div>
  );
};

// Protected Route component
function MonteurGeenToegang() {
  const { logout } = useAuth();
  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'#f3f4f6', fontFamily:'-apple-system,Segoe UI,Roboto,sans-serif', padding:24 }}>
      <div style={{ textAlign:'center', maxWidth:420 }}>
        <div style={{ fontSize:48, marginBottom:12 }}>📱</div>
        <h2 style={{ margin:'0 0 8px', fontSize:20, color:'#111827' }}>Gebruik de monteurs-app</h2>
        <p style={{ color:'#6b7280', fontSize:14, margin:'0 0 20px' }}>Dit account heeft geen toegang tot de kantooromgeving. Log in via de WOMsys monteurs-app.</p>
        <button onClick={logout} style={{ padding:'10px 20px', border:'none', background:'#4f46e5', color:'#fff', borderRadius:8, fontWeight:600, cursor:'pointer' }}>Uitloggen</button>
      </div>
    </div>
  );
}
const ProtectedRoute = ({ children }) => {
  const { isIngelogd, loading, gebruiker } = useAuth();
  const location = useLocation();
  
  if (loading) {
    return <div className="loading-screen">Laden...</div>;
  }
  
  if (!isIngelogd()) {
    return <Navigate to="/login" />;
  }
  
  if (gebruiker?.rol === 'monteur' && !isServicedesk() && !isFormsOnly()) {
    return <MonteurGeenToegang />;
  }
  if (location.pathname.startsWith("/admin")) {
    if (gebruiker?.rol !== "super_admin") return <Navigate to={HOME_PATH} replace />;
    return children;
  }
  return <Layout><LockScreen />{children}</Layout>;
};

// Public Route component
const PublicRoute = ({ children }) => {
  const { isIngelogd, loading } = useAuth();

  if (loading) {
    return <div className="loading-screen">Laden...</div>;
  }

  return !isIngelogd() ? children : <Navigate to={HOME_PATH} />;
};

const HOME_PATH = isServicedesk() ? '/servicedesk' : (isFormsOnly() ? '/forms/inbox' : '/dashboard');

function AppRoutes() {
  if (isServicedesk()) {
    return (
      <Routes>
        <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="*" element={<ProtectedRoute><ServicedeskApp /></ProtectedRoute>} />
      </Routes>
    );
  }
  return (
    <Routes>
      <Route path="/p/:actie/:token" element={<MagicLinkForm />} />
      <Route path="/v/:id" element={<VerifyPage />} />
      <Route path="/inhuur-respond/:token" element={<InhuurRespond />} />
        <Route path="/inhuur-bundel/:token" element={<InhuurBundelRespond />} />
        <Route path="/inzet/:token" element={<InzetReserveren />} />

      <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
      <Route path="/registreer" element={<PublicRoute><BedrijfRegistratie /></PublicRoute>} />
      <Route path="/wachtwoord-vergeten" element={<PublicRoute><WachtwoordVergeten /></PublicRoute>} />
      <Route path="/reset-wachtwoord" element={<PublicRoute><ResetWachtwoord /></PublicRoute>} />
      
      <Route path="/admin" element={<ProtectedRoute><AdminLayout><AdminDashboard /></AdminLayout></ProtectedRoute>} />
      <Route path="/admin/ideeen" element={<ProtectedRoute><AdminLayout><AdminIdeeen /></AdminLayout></ProtectedRoute>} />
      <Route path="/admin/nieuw" element={<ProtectedRoute><AdminLayout><AdminChangelog /></AdminLayout></ProtectedRoute>} />
      <Route path="/admin/themas" element={<ProtectedRoute><AdminLayout><ThemaBeheer /></AdminLayout></ProtectedRoute>} />
      <Route path="/admin/nieuws" element={<ProtectedRoute><AdminLayout><NieuwsBeheer admin /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/bedrijven" element={<ProtectedRoute><AdminLayout><SuperAdminPanel /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/abonnementen" element={<ProtectedRoute><AdminLayout><AdminAbonnementen /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/facturen" element={<ProtectedRoute><AdminLayout><AdminFacturen /></AdminLayout></ProtectedRoute>} />
        <Route path="/admin/demo-aanvragen" element={<ProtectedRoute><AdminLayout><DemoAanvragen /></AdminLayout></ProtectedRoute>} />
      <Route path="/afdelingen" element={<ProtectedRoute><AfdelingenBeheer /></ProtectedRoute>} />
      <Route path="/rollen-beheer" element={<ProtectedRoute><RollenBeheer /></ProtectedRoute>} />
      <Route path="/portal-beheer" element={<ProtectedRoute><PortalBeheer /></ProtectedRoute>} />
      <Route path="/live-scherm" element={<ProtectedRoute><LiveScherm /></ProtectedRoute>} />
      <Route path="/gebruikers" element={<ProtectedRoute><GebruikersBeheer /></ProtectedRoute>} />
      <Route path="/werkorder/:id" element={<ProtectedRoute><WerkorderDetail /></ProtectedRoute>} />
      <Route path="/checklist/:werkorderId" element={<ProtectedRoute><ChecklistInvullen /></ProtectedRoute>} />
      <Route path="/planning" element={<ProtectedRoute><PlanningRouter /></ProtectedRoute>} />
      <Route path="/klanten" element={<ProtectedRoute><Klantenboek /></ProtectedRoute>} />
      <Route path="/inzetmiddelen" element={<ProtectedRoute><Inzetmiddelen /></ProtectedRoute>} />
      <Route path="/opdrachtgevers" element={<ProtectedRoute><Opdrachtgevers /></ProtectedRoute>} />
      <Route path="/facturen" element={<ProtectedRoute><Facturen /></ProtectedRoute>} />
      <Route path="/brieven" element={<ProtectedRoute><Brieven /></ProtectedRoute>} />
      <Route path="/ideeen" element={<ProtectedRoute><Ideeen /></ProtectedRoute>} />
      <Route path="/ordernummers" element={<ProtectedRoute><Ordernummers /></ProtectedRoute>} />
      <Route path="/wagenpark" element={<ProtectedRoute><Wagenpark /></ProtectedRoute>} />
      <Route path="/nieuw" element={<ProtectedRoute><Nieuws /></ProtectedRoute>} />
      <Route path="/nieuw/live" element={<NieuwsLive />} />
      <Route path="/nieuw/beheer" element={<ProtectedRoute><NieuwsBeheer /></ProtectedRoute>} />
      <Route path="/nieuw/:id" element={<ProtectedRoute><NieuwsArtikel /></ProtectedRoute>} />
      <Route path="/changelog" element={<ProtectedRoute><Nieuw /></ProtectedRoute>} />
      <Route path="/brieven/:id" element={<ProtectedRoute><BriefEditor /></ProtectedRoute>} />
      <Route path="/monteur-logs" element={<ProtectedRoute><MonteurLogs /></ProtectedRoute>} />
      <Route path="/monteur-logs" element={<ProtectedRoute><MonteurLogs /></ProtectedRoute>} />
      <Route path="/klant/:id" element={<ProtectedRoute><KlantDetail /></ProtectedRoute>} />
      <Route path="/restwerk" element={<ProtectedRoute><RestwerkDashboard /></ProtectedRoute>} />
      <Route path="/toolboxen" element={<ProtectedRoute><Toolboxen /></ProtectedRoute>} />
      <Route path="/uren-export" element={<ProtectedRoute><UrenExport /></ProtectedRoute>} />
      <Route path="/afgerond" element={<ProtectedRoute><AfgerondeWerkorders /></ProtectedRoute>} />
      <Route path="/doorgestuurd" element={<ProtectedRoute><DoorgestuurdeWerkorders /></ProtectedRoute>} />
      <Route path="/onderaannemers" element={<ProtectedRoute><OnderaannemersBeheer /></ProtectedRoute>} />
      <Route path="/voorstellen" element={<ProtectedRoute><MijnVoorstellen /></ProtectedRoute>} />
      <Route path="/openstaand" element={<ProtectedRoute><OpenWerkorders /></ProtectedRoute>} />
      <Route path="/templates" element={<ProtectedRoute><ChecklistTemplates /></ProtectedRoute>} />
      <Route path="/metingen" element={<ProtectedRoute><MetingenInbox /></ProtectedRoute>} />
      <Route path="/checklist-blokken" element={<ProtectedRoute><ChecklistBlokken /></ProtectedRoute>} />
      <Route path="/thema-beheer" element={<ProtectedRoute><ThemaBeheer /></ProtectedRoute>} />
      <Route path="/import" element={<ProtectedRoute><Import /></ProtectedRoute>} />
      <Route path="/storingen" element={<ProtectedRoute><StoringenOverzicht /></ProtectedRoute>} />
      <Route path="/meldingen" element={<ProtectedRoute><Meldingen /></ProtectedRoute>} />
      <Route path="/melding/:id" element={<ProtectedRoute><MeldingDetail /></ProtectedRoute>} />
      <Route path="/projecten" element={<ProtectedRoute><Projecten /></ProtectedRoute>} />
      <Route path="/projecten/:id" element={<ProtectedRoute><ProjectDetail /></ProtectedRoute>} />
      <Route path="/onderhoud-overzicht" element={<ProtectedRoute><OnderhoudOverzicht /></ProtectedRoute>} />
      <Route path="/weekrapport" element={<ProtectedRoute><Weekrapport /></ProtectedRoute>} />
      <Route path="/monteur-koppels" element={<ProtectedRoute><MonteurKoppels /></ProtectedRoute>} />
      <Route path="/storing/:id" element={<ProtectedRoute><StoringDetail /></ProtectedRoute>} />
      <Route path="/topdesk" element={<ProtectedRoute><TopDeskIntegratie /></ProtectedRoute>} />
      <Route path="/kennisbank" element={<ProtectedRoute><KennisbankBeheer /></ProtectedRoute>} />
        <Route path="/forms" element={<ProtectedRoute><FormsBeheer /></ProtectedRoute>} />
        <Route path="/signalering" element={<ProtectedRoute><SignaleringBeheer /></ProtectedRoute>} />
        <Route path="/heatmap" element={<ProtectedRoute><GeoHeatmap /></ProtectedRoute>} />
      <Route path="/forms/inbox" element={<ProtectedRoute><FormsInboxPage /></ProtectedRoute>} />
      <Route path="/forms/instellingen" element={<ProtectedRoute><FormsInstellingen /></ProtectedRoute>} />
        <Route path="/forms/editor/:id" element={<ProtectedRoute><FormsEditor /></ProtectedRoute>} />
        <Route path="/forms/invullen/:id" element={<ProtectedRoute><FormsInvullen /></ProtectedRoute>} />
        <Route path="/forms/quick-sign-multi" element={<ProtectedRoute><QuickSignMulti /></ProtectedRoute>} />
        <Route path="/sign/:token" element={<SignPage />} />
        <Route path="/forms/bekijken/:id" element={<ProtectedRoute><FormsBekijken /></ProtectedRoute>} />
<Route path="/cursus-planner" element={<ProtectedRoute><CursusPlanner /></ProtectedRoute>} />
      <Route path="/bestellen" element={<ProtectedRoute><MateriaalBestellingen /></ProtectedRoute>} />
<Route path="/gebruiker/:id" element={<ProtectedRoute><MonteurProfiel /></ProtectedRoute>} />
      <Route path="/documenten" element={<ProtectedRoute><Documenten /></ProtectedRoute>} />
      <Route path="/formulieren" element={<ProtectedRoute><Formulieren /></ProtectedRoute>} />
      <Route path="/instellingen" element={<ProtectedRoute><Instellingen /></ProtectedRoute>} />
      <Route path="/analyse" element={<ProtectedRoute><Analyse /></ProtectedRoute>} />
      <Route path="/storing-analyse" element={<ProtectedRoute><StoringAnalyse /></ProtectedRoute>} />
      <Route path="/maandverslag" element={<ProtectedRoute><Maandverslag /></ProtectedRoute>} />
      <Route path="/storing-melden" element={<ProtectedRoute><StoringMelden /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/materialen-beheer" element={<ProtectedRoute><MaterialenBeheer /></ProtectedRoute>} />
      <Route path="/voorraad" element={<ProtectedRoute><VoorraadOverzicht /></ProtectedRoute>} />
      <Route path="/inhuur" element={<ProtectedRoute><Inhuur /></ProtectedRoute>} />
      <Route path="/" element={<Navigate to={HOME_PATH} />} />
      <Route path="*" element={<Navigate to={HOME_PATH} />} />
      <Route path="/onderhoud-forecast" element={<ProtectedRoute><OnderhoudForecast /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <FoutVanger>
    <BrowserRouter>
      <AuthProvider>
        <LayoutEditProvider>
        <ThemaLaag />
        <AppRoutes />
      </LayoutEditProvider>
      </AuthProvider>
    </BrowserRouter>
    </FoutVanger>
  );
}

export default App;
